<template>
  <div class="home-main">

	<div class="floto-box-1">
		<div class="title-1 wi8_font">
			What I Ate!
		</div>
		<div class="title-2">
			Food. Fun. Publog.
		</div>
	</div>

	<div class="floto-box-2">
		<div class="message"> 
			Welcome to What I Ate!
			<br/><br/>
			Have fun with this open forum and 
			<br/>
			share your food stories and photos
			<br/>
			with the world!
		</div>
	</div>

  </div>
</template>

<script>
import { m } from "@/utils/utils";
import { eventBus } from '@/main';
export default {
	created() {
		m("home created");
		eventBus.$emit('popoffall'); // Close all modal windows
	},
};
</script>

<style scoped>

.home-main {
	height: 100%;
	overflow: hidden;
	/* background-color: #F9F6F3; */
	background: url(../../assets/img/frontpage_201.jpg) no-repeat;
	border: solid 0px #090;
}

.floto-box-1 {
	position: relative;
	top: 50px;
	width: 280px;
	height: 120px;
	padding: 20px;
	overflow: hidden;
	background-color: rgba(0,0,0,0.2);
	/* background-color: rgba(252,249,243,0.6); */
	/* background-color: #FCF9F3; */
	border: 0px solid #C30;		
}

.floto-box-1v1 {
	position: relative;
	top: 40px;
	left: 30px;
	width: 300px;
	height: 120px;
	padding: 20px;
	overflow: hidden;
	border-radius: 8px;
	background-color: rgba(0,0,0,0.2);
	border: 0px solid #C30;		
}

.floto-box-2 {
	position: relative;
	top: 180px;
	/* left: 60px; */
	/* width: 300px; */
	height: 180px;
	padding: 20px;
	overflow: hidden;
	background-color: rgba(0,0,0,0.3);
	border: 0px solid #C30;		
}

.title-1 {
	height: 40px;
	overflow: hidden;
	font-size: 26px;
	font-weight: normal;
	word-spacing: 5px;
	color: #FFF;
	text-shadow: 2px 2px #000;
	border: 0px solid #FFF;		
}

.title-2 {
	height: 50px;
	overflow: hidden;
	font-size: 22px;
	font-weight: normal;
	word-spacing: 15px;
	/* color: #C60; */
	color: #FFF;
	text-shadow: 2px 2px #333;
	padding: 15px 0px 0px 0px;
	border: 0px solid #FFF;		
}
.message {
	height: 140px;
	overflow: hidden;
	font-size: 20px;
	text-align: center;
	color: #FFF;
	text-shadow: 2px 2px #666;
	border: 0px solid #f00;		
}

</style>
